import { render, staticRenderFns } from "./ArticleBanner.vue?vue&type=template&id=11d806d8&scoped=true&"
import script from "./ArticleBanner.vue?vue&type=script&lang=js&"
export * from "./ArticleBanner.vue?vue&type=script&lang=js&"
import style0 from "./ArticleBanner.vue?vue&type=style&index=0&id=11d806d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d806d8",
  null
  
)

export default component.exports